import { render } from "./EditSchedule.vue?vue&type=template&id=5f81c834&ts=true"
import script from "./EditSchedule.vue?vue&type=script&lang=ts"
export * from "./EditSchedule.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__